// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import ReviewOrderChangeRequestAddedLine from "@store/Library/Components/ReviewOrderChangeRequest/ReviewOrderChangeRequestAddedLine";
import ReviewOrderChangeRequestOrderLine from "@store/Library/Components/ReviewOrderChangeRequest/ReviewOrderChangeRequestOrderLine";
import { OrderLinesListStyles } from "@store/Overrides/Components/OrderLinesList";
import * as React from "react";
import { connect } from "react-redux";

const enum fields {
    showLineNumber = "showLineNumber",
}

const mapStateToProps = (state: ApplicationState) => ({
    order: getOrderState(state, state.pages.orderDetails.orderNumber),
});

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> & {
        [fields.showLineNumber]: boolean;
    };

export interface OrderChangeRequestDetailSummaryTableStyles {
    orderLines?: OrderLinesListStyles;
}

const ReviewOrderChangeRequestDetailsSummaryTable: React.FunctionComponent<Props> = ({ order, fields }) => {
    if (!order.value || !order.value.orderLines) {
        return null;
    }

    return <ReviewOrderChangeRequestOrderLine order={order.value} showLineNumber={fields.showLineNumber} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ReviewOrderChangeRequestDetailsSummaryTable),
    definition: {
        allowedContexts: ["ReviewOrderChangeRequestPage" as any],
        group: constants.widgetGroup.reviewOrderChangeRequest,
        fieldDefinitions: [
            {
                name: fields.showLineNumber,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                variant: "toggle",
            },
        ],
    },
};

export default widgetModule;
